import { init } from "@ln/user.client.libs";
import { Config } from "./config";

function UserClientLibs() {
  const suscipcionesSiteId = 18;
  const environment = window.config.Constantes.Environment;
  const DDServiceName = "paywall";
  
  return init({
    keyDatadog: Config.DDClientToken,
    googleIdClient: Config.googleClientId,
    siteId: suscipcionesSiteId,
    environment,
    serviceDatadog: DDServiceName,
  });
}

const UCL = UserClientLibs();

module.exports = {
  UCL,
};



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/UserClientLibs.js